// shadcn/ui native-select (CLI 4.21.0), rebound to docs/tokens.css.
//
// This is the kit's Select. It is a real <select>, so every page keeps its
// `onChange={(event) => set(event.target.value)}` exactly as written, the
// keyboard and the screen reader get the browser's own control, and a list
// of nine country codes needs nothing heavier.
//
// Changed from upstream: `className` styles the wrapper (width, min-width),
// the select fills it; the option colours fall back to the browser's.
import * as React from "react";
import { ChevronDownIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// forwardRef to the <select> itself: React 18 (see button.tsx).
const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  Omit<React.ComponentPropsWithoutRef<"select">, "size"> & { size?: "sm" | "default" }
>(function NativeSelect({ className, size = "default", ...props }, ref) {
  return (
    <div
      className={cn(
        "group/native-select relative inline-flex w-fit has-[select:disabled]:opacity-60",
        className,
      )}
      data-slot="native-select-wrapper"
    >
      <select
        ref={ref}
        data-slot="native-select"
        data-size={size}
        className={cn(
          "h-control w-full min-w-0 cursor-pointer appearance-none rounded-control border border-input bg-card py-0 pr-9 pl-3 text-body text-foreground outline-none transition-[border-color] dark:bg-muted",
          "focus-visible:border-primary disabled:cursor-not-allowed disabled:bg-muted aria-invalid:border-destructive",
          "data-[size=sm]:h-control-sm",
        )}
        {...props}
      />
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-primary select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  );
});

export { NativeSelect };
